export interface Country {
    country: string;
    province: string;
}

export interface Sta {
    name: string;
    ab: string;
    nameFr: string;
    nameEn: string;
}

export enum EnumAddressType {
    BILLING = 'BILLING',
    OLD = 'OLD',
    COMPANY = 'COMPANY',
}

export enum AddressStateEnum {
    UNKNOWN = 'UNKNOWN',
    VALID = 'VALID',
    INVALID = 'INVALID'
}

export enum UnitTypeEnum {
    APARTMENT = 'APARTMENT',
    SUITE = 'SUITE',
    UNIT = 'UNIT'
}

export interface Address {
    id: any;
    color: {};
    AddressType;
    type: EnumAddressType;
    company: string;
    appartment: string;
    addressLine1: string;
    addressLine2: string;
    country: string;
    province: string;
    city: string;
    zipCode: string;
    AddressStateEnum: AddressStateEnum;
    comment: string;
    checked: boolean;
    state: AddressStateEnum;
    statesWorld: any;
    statesCAD: any;
    statesUS: any;
    provinceAbvr:any;
    unitType: UnitTypeEnum;
}
